import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { useMemo } from 'react';
import useSWR from 'swr';
import { CryptoResponse } from '@/components/molecules/CryptoCarousel/types';
import { ROUTES } from '@/routes';
import { getCryptos } from '@/utils';
import { useLang } from '../useLang';
import { useCryptoChanges } from './hooks';
import { UseGetCryptosProps, CryptoChangeData } from './types';
export const useCryptos = t0 => {
  const $ = _c(29);
  const {
    coins,
    filter: t1
  } = t0;
  const filter = t1 === undefined ? "all" : t1;
  const lang = useLang();
  let t2;
  if ($[0] !== coins) {
    t2 = coins || [];
    $[0] = coins;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data: cryptoChanges,
    isLoading: isCryptoChangesLoading
  } = useCryptoChanges(t2);
  let t3;
  if ($[2] !== cryptoChanges) {
    t3 = cryptoChanges?.reduce(_temp, {});
    $[2] = cryptoChanges;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const cryptoChangesMap = t3;
  let t4;
  if ($[4] !== filter || $[5] !== lang) {
    t4 = [ROUTES.APICryptos, lang, filter];
    $[4] = filter;
    $[5] = lang;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== coins || $[8] !== filter || $[9] !== lang) {
    t5 = async () => {
      const response = await getCryptos({
        coins: coins || [],
        filter,
        locale: lang
      });
      return response;
    };
    $[7] = coins;
    $[8] = filter;
    $[9] = lang;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = isCryptoChangesLoading ? undefined : 10000;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      result: null,
      isLoading: true
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = {
      refreshInterval: t6,
      revalidateOnFocus: true,
      fallbackData: t7
    };
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const {
    data: cryptoResponse
  } = useSWR(t4, t5, t8);
  let t9;
  if ($[14] !== cryptoResponse?.result) {
    t9 = cryptoResponse?.result || [];
    $[14] = cryptoResponse?.result;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== cryptoChangesMap || $[17] !== t9) {
    let t11;
    if ($[19] !== cryptoChangesMap) {
      t11 = item => ({
        ...item,
        change: +(cryptoChangesMap?.[item.ticker?.toLowerCase() || ""]?.changePercent24Hr || 0)
      });
      $[19] = cryptoChangesMap;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    t10 = t9.map(t11);
    $[16] = cryptoChangesMap;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = cryptoResponse?.error;
  const t12 = cryptoResponse?.isLoading;
  let t13;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t12) {
    t13 = {
      result: t10,
      error: t11,
      isLoading: t12
    };
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = cryptoResponse?.isLoading;
  let t15;
  if ($[25] !== isCryptoChangesLoading || $[26] !== t13 || $[27] !== t14) {
    t15 = {
      data: t13,
      isLoading: t14,
      isCryptoChangesLoading
    };
    $[25] = isCryptoChangesLoading;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
};
function _temp(acc, curr) {
  acc[curr.data.symbol.toLowerCase()] = curr.data;
  return acc;
}